/**
 * Cart-Page – Verpackungseinheiten-Rundung
 *  Jeder Mengen-Input braucht:
 *    data-pack-unit="6"
 *    data-line-key="abcdef123"
 */

(() => {
  const round = (v, u) => Math.round((parseInt(v, 10) || 0) / u) * u || u;

  /* Backend sync mit kleinem Debounce */
  const timers = new Map();
  function sync(lineKey, qty) {
    clearTimeout(timers.get(lineKey));
    timers.set(lineKey, setTimeout(async () => {
      await fetch('/cart/change.js', {
        method :'POST',
        headers:{ 'Content-Type':'application/x-www-form-urlencoded' },
        body   : `id=${encodeURIComponent(lineKey)}&quantity=${qty}`
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      timers.delete(lineKey);
    }, 150));
  }

  function normalize(inp) {
    const unit = parseInt(inp.dataset.packUnit || 1, 10);
    if (unit <= 1) return;                          // keine VE hinterlegt
    const next = round(inp.value, unit);

    if (next !== parseInt(inp.value, 10)) {
      inp.value = next;
      inp.dispatchEvent(new Event('input',  { bubbles: true }));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const key = inp.dataset.lineKey;
    if (key) sync(key, next);
  }

  /* Nur bei Blur (Feld verlassen) oder offiziellem change/Enter runden */
  const handler = e => {
    const inp = e.target.closest('input[data-pack-unit]');
    if (inp) normalize(inp);
  };

  document.addEventListener('change', handler);   // Enter, Pfeile, +/--Buttons
  document.addEventListener('blur',   handler, true); // Feld verlassen (capture)
})();